import React, { useState, useEffect } from 'react'
import Axios from 'axios'
import { Link, Redirect, useParams } from "react-router-dom"
import Header from '../../../Header';
import { Host } from '../../../App';
import throttle from 'lodash/throttle';
import { toast } from 'react-toastify';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


function Temp_Inventory() {
  var [del, setdel] = useState(1);
  const [postList, setPostList] = useState([]);
  const [Date1, setDate1] = useState(new Date());
  const [Postartdate, setPoStartdate] = useState('2025-06-14');
  const [customer, setCustomer] = useState({});
  const [Partdesc, setPartdesc] = useState({});
  var token = (window.localStorage.getItem("acessToken"));
  var totalQtyShipped = 0;
  useEffect(() => {
    var timer = setInterval(() => setDate1(new Date()), 10)
    return function cleanup() {
      clearInterval(timer)
    }
  });
  const queryParams = {
    enddate: Postartdate,
    Customer: customer,
    Part_Desc: Partdesc,
    token: token,
  };
  useEffect(() => {
    Axios.get(`https://${Host}/realapi/Production/Temp_Inventory`, { params: queryParams })
      .then((response) => {
        console.log("Fetched Data:", response.data);
        setPostList(response.data); // Directly set the fetched data
      })
      .catch((error) => {
        console.error("Error fetching production schedule:", error);
      });
  }, [Postartdate, customer, Partdesc]);


  return (
    <div className="MainPage_data">
      <div>
        <br></br>
        <Link to="/">
          <input type="button" class="btn btn-success" defaultValue="Logout" id="logout" />
        </Link>
      </div>
      <div class="Container">
        <h1>Trial Temporary Inventory</h1>
        <div class="row">
          <div class="col">

          </div>
          <div class="col">
            {/* Grab the particular Operator name */}
            <input type='text' class="form-control form-rounded" placeholder='Part Description' list="Customers" onChange={(e) => {
              setCustomer(e.target.value)
            }} />
            <datalist id="Customers">
              <option></option>
              {[...new Set(postList.map(x => x.Customer))].map(customer => (
                <option key={customer}>{customer}</option>
              ))}

            </datalist>

          </div>
          <div class="col">
            <div class="row" >
              <div class="col" id='moldng'>
                {/* Grab the particular dates */}
                <input type='date' class="form-control form-rounded" placeholder='PO SHIP DATE' defaultValue={Postartdate} onChange={(e) => {
                  setPoStartdate(e.target.value)

                }} />
                {/*<button class="btn btn-success" onClick={dates}>Submit</button > */}


              </div>

            </div>
          </div>
          <div class="col">
            <div class="row">
              <input type='text' class="form-control form-rounded" placeholder='Customer' list='Part_Desc' onChange={(e) => {
                setPartdesc(e.target.value)
              }} />
              <datalist id="Part_Desc">
                <option></option>
                {postList.map(x => {
                  return <option>{x.Part_Description}</option>
                })}
              </datalist>
            </div>

          </div>
        </div>
        <br></br>
        <br></br>
        <table class="table table-bordered table-striped">
          <thead>
            <tr>
              <th>PART NO</th>
              <th>INTERNAL PART NO</th>
              <th>PART DESCRIPTION</th>
              <th>CUSTOMER</th>
              <th>INVENTORY QTY</th>
              <th>PRODUCED PARTS</th>
              <th>SHIPPED PARTS</th>
              <th>PENDING PARTS</th>
            </tr>
          </thead>
          <tbody>
            {postList.map((val, key) => {
              return (
                <tr key={key}>
                  <td>{val.Part_No}</td>
                  <td>{val.Internal_Part_No}</td>
                  <td>{val.Part_Description}</td>
                  <td>{val.Customer}</td>
                  <td>{val.Inventory_QTY}</td>
                  <td>{val.Produced_Parts}</td>
                  <td>{val.Shipped_Parts}</td>
                  <td>{val.Pending_Parts}</td>
                </tr>


              )
            })}
          </tbody>
          <thead>
          </thead>
        </table>
      </div>


    </div >
  )
}

export default Temp_Inventory;